// @ts-check

import "../jsdoc-types"
import {
	doConsentAction,
} from "../../../../../../../consent/src/main/resources/scripts/modules/consent-functions.js";

/**
 * @param {Object} props
 * @param {PrivacyCenterLinkEntry} props.cdaEntry
 */
export function PrivacyCenterLink({ cdaEntry }) {
	return (
		// DeSy component `Link` can't be used because it doesn't pass custom attributes along
		<button
			type="button"
			onClick={() => doConsentAction(cdaEntry.fields.action)}
			data-privacy-center={cdaEntry.fields.action || "openPrivacyCenter"}
			className="preflight rounded-sm inline-flex before:content-['_'] before:whitespace-pre before:w-0 relative items-center focus-visible:outline focus-visible:outline-clr-primary focus-visible:outline-1 typography-link-large text-clr-primary underline underline-offset-2 hover:decoration-2 group-focus:no-underline"
		>
			{cdaEntry.fields.label}
		</button>
	);
}
